// extracted by mini-css-extract-plugin
export default {"pageContainer":"Style_pageContainer__CvCe2","cardContainer":"Style_cardContainer__t3Z1B","truncateTitle":"Style_truncateTitle__HerVD","avatar":"Style_avatar__9JvhB"};